import http from "../../http-common";

const createProductColoplast = (data) => http.post("/Product/InsertUpdateProductColoplast", data);
const getProductColoplast = (data) => http.post("/Product/GetProductColoplast", data);

const createProductUfi = (data) => http.post("/Product/InsertUpdateProductUfi", data);
const getProductUfi = (data) => http.post("/Product/GetProductUfi", data);

const createProductGeneric = (data) => http.post("/Product/InsertUpdateProductGeneric", data);
const getProductGeneric = (data) => http.post("/Product/GetProductGeneric", data);

const createProductMotul = (data) => http.post("/Product/InsertUpdateProductMotul", data);
const getProductMotul = (data) => http.post("/Product/GetProductMotul", data);

export default {
    createProductColoplast,
    getProductColoplast,
    createProductUfi,
    getProductUfi,
    createProductGeneric,
    getProductGeneric,
    createProductMotul,
    getProductMotul
};